import React from "react";
import { Button } from "./button";
import { Loader2 } from "lucide-react";

interface LoaderButtonProps extends React.ComponentProps<typeof Button> {
  loading?: boolean;
  children: React.ReactNode;
}

export const LoaderButton: React.FC<LoaderButtonProps> = ({
  loading,
  children,
  disabled,
  ...props
}) => (
  <Button disabled={loading || disabled} {...props}>
    {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
    {children}
  </Button>
);
